import { css } from 'styled-components'
import { transition } from 'utils'

const baseFade = (durationInterpolation) => css`
  opacity: 1;

  &.fade-enter {
    opacity: 0.01;
  }

  &.fade-enter-active {
    opacity: 1;
    transition: opacity ${durationInterpolation} ease-out;
  }

  &.fade-exit {
    opacity: 1;
  }

  &.fade-exit-active {
    opacity: 0.01;
    transition: opacity ${durationInterpolation} ease-out;
  }
`

const fastFade = baseFade(transition('fast'))

export { fastFade }
